module.exports = __webpack_public_path__ + "static/media/tt_commons_regular-webfont.801b1747.woff2";